/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var PersonAddOutlineIcon = function PersonAddOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2C8.23858 2 6 4.23858 6 7C6 8.39171 6.56859 9.65062 7.48615 10.5571C4.45427 11.5517 2.04765 13.8008 1.05486 16.6734L0.72821 17.6185L2.6185 18.2718L2.94515 17.3266C3.99543 14.2877 7.16425 12 11 12C12.7914 12 14.4444 12.5011 15.8025 13.3484L16.6509 13.8777L17.7095 12.1809L16.8611 11.6516C16.1378 11.2003 15.3502 10.8308 14.5143 10.5566C15.4316 9.65017 16 8.39146 16 7C16 4.23858 13.7614 2 11 2ZM8 7C8 5.34315 9.34315 4 11 4C12.6569 4 14 5.34315 14 7C14 8.65685 12.6569 10 11 10C9.34315 10 8 8.65685 8 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17V14H21V17H24V19H21V22H19V19H16V17H19Z"
  }));
};
export default PersonAddOutlineIcon;